import React from 'react'
import { Button, Card, Col, Row, Space } from 'antd'
import './CardView.css'
import Text from "antd/lib/typography/Text"
import {
    isCreatorOrAdministrator,
    userHasRoles
} from "../../utils/UserInfo"
import CommentsIcon from "../CommentsIcon";
import UndoPopUp from "../UndoPopUp";
import { tabNamesMap } from "../TabNamesMap";
import { getToolTipFormatedList, getToolTipFormatedStr } from "../Utils/String";
import ProgressBarComp from 'containers/common/ProgressBarComp'
import CLExclamationIcon from "components/ExclamationIcon/CLExlamationIcon";

export default function CardView(props) {
    const { project, onButtonClick, history, context, allTab, loading } = props;

    function getActionsForStatus() {
        let actions = [];
        if (project.projectStatus === 'U') {
            actions.push(isCreatorOrAdministrator() ?
                <Button id={'upcomingCardEditLink'} type={"link"} style={{ height: 'auto' }}
                    onClick={() => onButtonClick(project)}>Start Project</Button> : <Text>Contact a Checklist Creator to Start Project</Text>)
        } else if (project.projectStatus === 'N') {
            actions.push(!isCreatorOrAdministrator() ? <Text>Contact a Checklist Creator to Re-Activate</Text> :
                <UndoPopUp
                    style={{ marginLeft: '20px', padding: '5px' }}
                    project={project}
                    history={history}
                    context={context}
                    undoStatus={"Re-Activate"} />)
        }
        if (project.projectStatus === 'A') {
            actions.push(userHasRoles() ? <Button id={'activeCardEditLink'} type={"link"} style={{ height: 'auto' }} onClick={() => onButtonClick(project)}>Go To Project</Button> : <Text>Contact CCA</Text>)
        } else if (project.projectStatus === 'C') {
            actions.push(userHasRoles() ? <Button id={'closedCardEditLink'} type={"link"} style={{ height: 'auto' }} onClick={() => onButtonClick(project)}>Go To Project</Button> : <Text>Contact CCA</Text>);
        } else if (project.projectStatus === 'R') {
            actions.push(userHasRoles() ? <Button id={'releaseCardEditLink'} type={"link"} style={{ height: 'auto' }} onClick={() => onButtonClick(project)}>Go To Project</Button> : <Text>Contact CCA</Text>);
        } else if (project.projectStatus === 'D') {
            actions.push(userHasRoles() ? <Button id={'inDevCardEditLink'} type={"link"} style={{ height: 'auto' }} onClick={() => onButtonClick(project)}>Go To Project</Button> : <Text>Contact CCA</Text>);
        }
        return actions;
    }

    function getCardTypeHeader() {
        switch (project.projectStatus) {
            case "A":
                return {
                    backgroundColor: "#7eb941",
                    minWidth: "120px",
                    height: "70px",
                    padding: "4px",
                    fontSize: "16px",
                    textAlign: "center",
                    color: "#fff"
                };
            case "C":
                return {
                    backgroundColor: "#2d7d2d",
                    minWidth: "120px",
                    height: "70px",
                    padding: "4px",
                    fontSize: "16px",
                    textAlign: "center",
                    color: "#fff"
                };
            case "D":
                return {
                    backgroundColor: "#0077b5",
                    minWidth: "120px",
                    height: "70px",
                    padding: "4px",
                    fontSize: "16px",
                    textAlign: "center",
                    color: "#fff"
                };
            case "N":
                return {
                    backgroundColor: "#c1370d",
                    minWidth: "120px",
                    height: "70px",
                    padding: "4px",
                    fontSize: "16px",
                    textAlign: "center",
                    color: "#fff"
                };
            case "R":
                return {
                    backgroundColor: "#dc8525",
                    minWidth: "120px",
                    height: "70px",
                    padding: "4px",
                    fontSize: "16px",
                    textAlign: "center",
                    color: "#fff"
                };
            case "U":
                return {
                    backgroundColor: "#34b3e4",
                    minWidth: "120px",
                    height: "70px",
                    padding: "4px",
                    fontSize: "16px",
                    textAlign: "center",
                    color: "#fff"
                };
        }
    }

    return (
        <Card title={<span>{project.stationName !== null ? project.stationName : ' '}
            <br /> {(allTab && allTab === 'Y') && project.projectStatus !== null ? tabNamesMap[project.projectStatus] : ' '}</span>}
            id={'cardId' + project.id}
            actions={getActionsForStatus()}
            headStyle={getCardTypeHeader()}
            bodyStyle={
                project.projectStatus == 'A' || project.projectStatus == 'R' ?
                    {
                        fontSize: "12px", backgroundColor: "#ffffff",
                        maxHeight: "31rem",
                        minHeight: "31rem"
                    } :
                    {
                        fontSize: "12px", backgroundColor: "#ffffff",
                        maxHeight: "25.5rem",
                        minHeight: "25.5rem"
                    }

            }
            style={{ marginBottom: "16px", boxShadow: "5px 5px 5px lightgrey" }}
            loading={loading}
        >
            <div>
                <b>Project Description</b> <CommentsIcon project={project} /> {project.exceptionCnt > 0 && <CLExclamationIcon project={project} />}
                <br />
                <div>{project.linkProjectCount === 0 ? project.projectDescription : getToolTipFormatedList(project.allProjectDescs)}</div>
                {/* <br /> */}
                <hr />

                <div className={project.constructionDue ? "red-date" : "upc-date"}> <b>Construction Start Date:</b> {project.constructionStartDate} </div>
                {(project.projectStatus !== 'N') && (project.projectStatus !== 'U') && <div className={project.commissioningDue ? "red-date" : "upc-date"}>
                    <b>Checklist Release Date:</b> {project.commisioningStartDate}
                </div>}
                <div className={project.inServiceDue ? "red-date" : "upc-date"}>
                    <b>In-Service Date:</b> {project.inServiceDate}
                </div>
                {(project.projectStatus === 'R' || project.projectStatus === 'A' || project.projectStatus === 'C') &&
                    <div className={project.ecdDue && project.projectStatus !== 'C' ? "red-date" : "upc-date"} >
                        <b>Expected Close Date:</b> {project.defExpectedCloseDate}
                    </div>}
                <hr />
                <div>{getToolTipFormatedStr('WO', project.workOrder, project.id)}</div>
                <div>{getToolTipFormatedStr('BPID', project.bpid, project.id)}</div>
                <div>{getToolTipFormatedStr('MPID', project.mpid, project.id)}</div>
                <hr />
                <div>
                    <b>Station Region:</b> {project.stationRegion}
                    <br />
                    <b>TFS Station Area:</b> {project.tfStationArea}
                    <br />
                    <b>TFS P&C Area:</b> {project.pcArea}
                </div>
                <hr />
                Total of {project.noOfAssets} Assets
                <br />
                Total of {project.noOfSectionAssets} Assets Assigned Section(s)
                <br />
                {(project.projectStatus === 'R' || project.projectStatus === 'A' || project.projectStatus === 'C') &&
                    <> Total of {project.noOfFormAssets} Assets Assigned to Pre-E Form(s)
                    </>}
                <hr />
                {(project.projectStatus === 'R' || project.projectStatus === 'A') &&
                    <>
                        <Row style={{ padding: '3px 0px' }}><Col span={8}><b>Project Tasks:</b></Col>
                            <Col span={16}>
                                <ProgressBarComp
                                    progressBarProps={[{ bgcolor: 'green', taskPercent: Number(project.projectTaskPercent).toFixed(2) },
                                    { bgcolor: 'gray', taskPercent: Number(project.projectTaskInCompPercent).toFixed(2) },
                                    { bgcolor: 'yellow', taskPercent: Number(project.projectTaskTempPercent).toFixed(2) }
                                    ]}
                                    style={{
                                        borderRadius: '.25rem',
                                        height: '1rem',
                                        overflow: 'hidden',
                                        fontSize: '.75rem',
                                        color: 'black'
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row style={{ padding: '3px 0px' }}><Col span={8}><b>Asset Tasks:</b></Col>
                            <Col span={16}>
                                <ProgressBarComp
                                    progressBarProps={[{ bgcolor: 'green', taskPercent: Number(project.assetTaskPercent).toFixed(2) },
                                    { bgcolor: 'gray', taskPercent: Number(project.assetTaskInCompPercent).toFixed(2) },
                                    { bgcolor: 'yellow', taskPercent: Number(project.assetTaskTempPercent).toFixed(2) }
                                    ]}
                                    style={{
                                        borderRadius: '.25rem',
                                        height: '1rem',
                                        overflow: 'hidden',
                                        fontSize: '.75rem',
                                        color: 'black'
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row style={{ padding: '3px 0px' }}><Col span={8}><b>Pre-E Tasks:</b></Col>
                            <Col span={16}>
                                <ProgressBarComp
                                    progressBarProps={[{ bgcolor: 'green', taskPercent: Number(project.preFormTaskPercent).toFixed(2) },
                                    { bgcolor: 'gray', taskPercent: Number(project.preFormTaskInCompPercent).toFixed(2) },
                                    { bgcolor: 'yellow', taskPercent: Number(project.preFormTaskTempPercent).toFixed(2) }
                                    ]}
                                    style={{
                                        borderRadius: '.25rem',
                                        height: '1rem',
                                        overflow: 'hidden',
                                        fontSize: '.75rem',
                                        color: 'black'
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                }
            </div>
        </Card>
    )

}


